{
  "Upload picture": "Upload photo",
  "allowed-file-types": "Only PNG or JPG files are allowed — <0>(Max 4 MB)</0>",
  "Choose a file…": "Choose a file",
  "Upload": "Upload",
  "Reset": "Reset",
  "Profile picture": "Profile picture",
  "Original picture": "Original picture"
}
